import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LdSvgIconModule } from '../svg-icon/svg-icon.module';
import { TitleDarkComponent } from './title-dark.component';

@NgModule({
  declarations: [
    TitleDarkComponent
  ],
  exports: [
    TitleDarkComponent
  ],
  imports: [
    CommonModule,
    LdSvgIconModule,
  ],
  providers: [ ]
})
export class TitleDarkModule { }
